import { Outlet } from 'react-router-dom';
import AppHeader from './AppHeader';

export default function DashboardLayout(): JSX.Element {
  return (
    <div className="min-h-full">
      <AppHeader />
      <main className="mx-auto max-w-7xl px-6 py-8">
        <Outlet />
      </main>
    </div>
  );
}
